



























import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';

@Component
export default class TemplateRenderer extends Vue {
    constructor() {
        super();
    }

    public cancel() {
        this.$store.commit(Mutations.TEMPLATE_RENDERER_OVERLAY_VISIBILITY, false);
    }

    get templateRenderer() {
        return this.$store.getters['TemplateRenderer/getTemplateRenderer'];
    }
}
